"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = require("react");
var _invariant = _interopRequireDefault(require("invariant"));
var _router = require("../router");
var _recompose = require("../recompose");
var _withAuth = _interopRequireDefault(require("./withAuth"));
var AuthCallback = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2.default)(AuthCallback, _Component);
  function AuthCallback() {
    return _Component.apply(this, arguments) || this;
  }
  var _proto = AuthCallback.prototype;
  _proto.componentDidMount = function componentDidMount() {
    var _this = this;
    var _this$props = this.props,
      auth = _this$props.auth,
      location = _this$props.location;
    var client = auth.client;
    (0, _invariant.default)(client, "AuthClient missing in context. " + "Did you forget to wrap your app in AuthProvider?");
    if (/access_token|id_token|error/.test(location.hash) || /code/.test(location.search)) {
      client.handleAuthentication(function (err, result) {
        if (err) {
          if (_this.props.onError != null) {
            _this.props.onError(err);
          }
        } else if (_this.props.onSuccess != null) {
          _this.props.onSuccess(result);
        }
      });
    }
  };
  _proto.render = function render() {
    return this.props.children;
  };
  return AuthCallback;
}(_react.Component);
AuthCallback.defaultProps = {
  children: undefined,
  onSuccess: undefined,
  onError: undefined
};
var enhance = (0, _recompose.compose)(_router.withRouter, _withAuth.default);
var _default = exports.default = enhance(AuthCallback);